
export const BREAKPOINT_2_COLUMNS = 1100;
export const BREAKPOINT_1_COLUMNS = 800;